// <head> страницы ♥ «Сохранённые» /{lang}/tutors/saved: noindex, без canonical
// и hreflang (в sitemap её нет), стили карты и формы (поля, чипы, карточки).
import tjCss from "./tutor-join.css?url";
import tmCss from "./tutors-map.css?url";
import { MAP_UX } from "./map-ux-copy";
import type { SiteLang } from "@/components/site/SiteChrome";
import { SITE_CHROME_LINKS } from "@/components/site/site-chrome-head";

export function tutorsSavedHead(lang: SiteLang) {
  return {
    meta: [{ title: `${MAP_UX[lang].savedTitle} — Yolutap` }, { name: "robots", content: "noindex, nofollow" }],
    links: [...SITE_CHROME_LINKS, { rel: "stylesheet", href: tjCss }, { rel: "stylesheet", href: tmCss }],
  };
}
